import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useGrupoStore = defineStore('grupo', () => {
  const selectedGroupId = ref(null)

  // Método para alterar o grupo selecionado
  const setSelectedGroupId = (id) => {
    selectedGroupId.value = id
  }

  // Computed para acessar facilmente o valor
  const getSelectedGroupId = computed(() => selectedGroupId.value)

  return {
    selectedGroupId,
    setSelectedGroupId,
    getSelectedGroupId
  }
}, {
  persist: true // mantém o grupo selecionado após F5 / reload
})
